import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from ".";
import { IMacroTypeModel, MacroTypeModel } from "./MacroTypeModel";

export interface IMacroModel extends IModel {
    macroId: number
    name: string
    macroTypeId: number
    macroType: IMacroTypeModel
    content: string
    hospitalId: number
    userId: number
    createdByUserId: number | undefined
    dateCreated: string
    userCreated: string
    dateUpdated: string
    userUpdated: string
    isActive: boolean
}

export class MacroModel extends Model implements ModelRecord<IMacroModel> {
    macroId: number
    name: string
    macroTypeId: number
    macroType: MacroTypeModel
    content: string
    hospitalId: number
    userId: number
    createdByUserId: number | undefined
    dateCreated: DateTime
    userCreated: string
    dateUpdated: DateTime
    userUpdated: string
    isActive: boolean

    constructor(params: Partial<IMacroModel>) {
        super(params);
        this.macroId = _.defaultTo(params?.macroId, 0);
        this.name = _.defaultTo(params.name, "");
        this.macroTypeId = _.defaultTo(params?.macroTypeId, 0);
        this.macroType = new MacroTypeModel(params?.macroType);
        this.content = _.defaultTo(params.content, "");
        this.hospitalId = _.defaultTo(params?.hospitalId, 0);
        this.userId = _.defaultTo(params?.userId, 0);
        this.createdByUserId = _.defaultTo(params?.createdByUserId, undefined);
        this.dateCreated = params.dateCreated ? DateTime.fromISO(params.dateCreated, { zone: "utc" }) : DateTime.min();
        this.userCreated = _.defaultTo(params.userCreated, "");
        this.dateUpdated = params.dateUpdated ? DateTime.fromISO(params.dateUpdated, { zone: "utc" }) : DateTime.min();
        this.userUpdated = _.defaultTo(params.userUpdated, "");
        this.isActive = _.defaultTo(params?.isActive, false);
    }
}
